import React, { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const Recaptcha = forwardRef(({ onVerify, onExpire, ...props }, ref) => {
  const [token, setToken] = useState(null);
  const recaptchaRef = useRef();

  useImperativeHandle(ref, () => ({
    getToken: () => token,
    reset: () => {
      setToken(null);
      if (recaptchaRef.current) recaptchaRef.current.reset();
    }
  }));

  const handleChange = (value) => {
    setToken(value);
    if (onVerify) onVerify(value);
  };

  const handleExpired = () => {
    setToken(null);
    if (onExpire) onExpire();
  };

  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={siteKey}
      onChange={handleChange}
      onExpired={handleExpired}
      {...props}
    />
  );
});

export default Recaptcha;